import { useRecentReza } from '../useRecentReza';
import { useRezaSelection } from '../useRezaSelection';
import { findRezaByCode } from '../utils';
import type { UseActiveRezaItemResult } from './useActiveRezaItem.types';

export const useActiveRezaItem = (): UseActiveRezaItemResult => {
	const { activeReza } = useRezaSelection();
	const { data } = useRecentReza();
	const rezaByCode = findRezaByCode(data, activeReza?.kod);

	return rezaByCode;
};
